module.exports = __webpack_public_path__ + "img/nota-codigo-firma.7744c6ce.png";